import type { SelectField } from '@payloadcms/plugin-form-builder/types'
import type { Control, FieldErrorsImpl } from 'react-hook-form'

import { Label } from '@onclicks/sharedcomponents/ui/Label'
import {
  Select as SelectComponent,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@onclicks/sharedcomponents/ui/Select'
import { Width } from '@onclicks/sharedcomponents/FieldForm/Width'
import React from 'react'
import { Controller } from 'react-hook-form'

import { Error } from '@onclicks/sharedcomponents/FieldForm/Error'

export const Select: React.FC<
  SelectField & {
    control: Control
    errors: Partial<FieldErrorsImpl>
  }
> = ({ name, control, errors, label, options, required, width, defaultValue }) => {
  return (
    <Width width={width} className="flex flex-col gap-2">
      <Label htmlFor={name} className="text-primary font-bold">
        {label}
        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        render={({ field: { onChange, value } }) => {
          const controlledValue = options.find((t) => t.value === value)

          return (
            <SelectComponent onValueChange={(val) => onChange(val)} value={controlledValue?.value}>
              <div className="gradient-border rounded-full focus-visible:ring-secondary/50 focus-visible:ring-offset-0">
                <SelectTrigger
                  className="rounded-full w-full border-0 bg-pink-200 focus-visible:ring-secondary/50 focus-visible:ring-offset-0 text-primary data-placeholder:text-primary/60"
                  id={name}
                >
                  <SelectValue placeholder={label} />
                </SelectTrigger>
              </div>
              <SelectContent className="rounded-3xl border-secondary/30">
                {options.map(({ label, value }) => {
                  return (
                    <SelectItem key={value} value={value}>
                      {label}
                    </SelectItem>
                  )
                })}
              </SelectContent>
            </SelectComponent>
          )
        }}
        rules={{ required }}
      />
      {errors[name] && <Error name={name} />}
    </Width>
  )
}
